import React, { Component } from "react";
import { Row, Col, Card, CardBody, Modal, Label, ModalHeader, ModalBody, UncontrolledTooltip } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { isEmpty, size } from "lodash";
import { showToast } from '../../UI/ui-toast'
import { get_user_permissions } from "../../../helpers/custom_helper"
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { get_all_sales, cancel_sale, sale_document_mail, generated_docs_detail } from '../api/salesApi';
import CancelModal from "components/Common/CancelModal";
import QuickInfoModal from "./Common/QuickInfoModal";
import WelcomePaymentModal from "./Common/WelcomePaymentModal";
import SummaryStatementModal from "./Common/SummaryStatementModal";
import SendEmailModal from "./Common/SendEmailModal";
var saleEdit, saleView, saleCreate, saleDelete, saleLog, paymentsLog, saleDocumentView, salesDocumentsEmailSend;
class ListSales extends Component {
    constructor(props) {
        super(props);
        this.node = React.createRef();
        this.state = {
            page: 1,
            sizePerPage: 10,
            listData: [],
            listdata: "",
            viewmodal: false,
            modal: false,
            isOpen: false,
            selectDate: false,
            deleteModal: false,
            cancelModal: false,
            infoModal: false,
            sendEmailModal: false,
            sendEmailModalID: '',
            welcomeLetterModal: false,
            paymentScheduleModal: false,
            paymentSummaryModal: false,
            statementAccountsModal: false,
            recordDeleteID: null,
            redirect: null,
            generated_docs_detail_response: null,
        };
        this.handleRecordClick = this.handleRecordClick.bind(this);
        this.handleListPayment = this.handleListPayment.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleRecordClicks = this.handleRecordClicks.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onClickInfo = this.onClickInfo.bind(this);
        this.onClickWelcomeLetter = this.onClickWelcomeLetter.bind(this);
        this.onClickPaymentSchedule = this.onClickPaymentSchedule.bind(this);
        this.onClickPaymentSummary = this.onClickPaymentSummary.bind(this);
        this.onClickStatementAccounts = this.onClickStatementAccounts.bind(this);
        this.onClickActivityLog = this.onClickActivityLog.bind(this);
        this.onClickActivityLogPayments = this.onClickActivityLogPayments.bind(this);
        this.onClickSendEmail = this.onClickSendEmail.bind(this);
    }
    componentDidMount() {
        saleEdit = get_user_permissions('sales-edit');
        saleView = get_user_permissions('sales-view');
        saleCreate = get_user_permissions('sales-create');
        saleDelete = get_user_permissions('sales-delete');
        saleLog = get_user_permissions('sale-logs-view');
        saleDocumentView = get_user_permissions('sale-documents-view');
        salesDocumentsEmailSend = get_user_permissions('sale-document-email-create');
        paymentsLog = get_user_permissions('payments-logs-view');
        window.localStorage.removeItem("payments_sale_id")
        window.localStorage.removeItem("current_payment_id")
        Promise.all([get_all_sales()]).then((values) => {
            this.setState({ listData: values[0] });
        });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { listData } = this.props;
        if (!isEmpty(listData) && size(prevProps.listData) !== size(listData)) {
            this.setState({ listData: {}, isEdit: false });
        }
    }
    onPaginationPageChange = page => {
        if (
            this.node &&
            this.node.current &&
            this.node.current.props &&
            this.node.current.props.pagination &&
            this.node.current.props.pagination.options
        ) {
            this.node.current.props.pagination.options.onPageChange(page);
        }
    };
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    toggleCancelModal = () => {
        this.setState(prevState => ({
            cancelModal: !prevState.cancelModal,
        }));
    };
    toggleQuickInfoModal = () => {
        this.setState(prevState => ({
            infoModal: !prevState.infoModal,
        }));
    };
    toggleSendEmailModal = () => {
        this.setState(prevState => ({
            sendEmailModal: !prevState.sendEmailModal,
        }));
    };
    toggleWelcomeLetterModal = () => {
        this.setState(prevState => ({
            welcomeLetterModal: !prevState.welcomeLetterModal,
        }));
    };
    togglePaymentScheduleModal = () => {
        this.setState(prevState => ({
            paymentScheduleModal: !prevState.paymentScheduleModal,
        }));
    };
    togglePaymentSummaryModal = () => {
        this.setState(prevState => ({
            paymentSummaryModal: !prevState.paymentSummaryModal,
        }));
    };
    toggleStatementAccountsModal = () => {
        this.setState(prevState => ({
            statementAccountsModal: !prevState.statementAccountsModal,
        }));
    };
    onClickDelete = listdata => {
        this.setState({ listdata: listdata });
        this.setState({ deleteModal: true });
    };
    onClickCancel = listdata => {
        this.setState({ listdata: listdata });
        this.setState({ cancelModal: true });
    };
    onClickInfo = listdata => {
        this.setState({ listdata: listdata });
        this.setState({ infoModal: true });
    };
    onClickWelcomeLetter = listdata => {
        Promise.all([generated_docs_detail(listdata.id)]).then((values) => {
            this.setState({ generated_docs_detail_response: values[0] })
            this.setState({ listdata: listdata });
            this.setState({ welcomeLetterModal: true });
        });
    };
    onClickPaymentSchedule = listdata => {
        Promise.all([generated_docs_detail(listdata.id)]).then((values) => {
            this.setState({ generated_docs_detail_response: values[0] })
            this.setState({ listdata: listdata });
            this.setState({ paymentScheduleModal: true });
        });
    };
    onClickPaymentSummary = listdata => {
        Promise.all([generated_docs_detail(listdata.id)]).then((values) => {
            this.setState({ generated_docs_detail_response: values[0] })
            this.setState({ listdata: listdata });
            this.setState({ paymentSummaryModal: true });
        });
    };
    onClickStatementAccounts = listdata => {
        Promise.all([generated_docs_detail(listdata.id)]).then((values) => {
            localStorage.setItem("statement-of-accounts-generated", values[0].statement_of_accounts_generate)
            this.setState({ generated_docs_detail_response: values[0] })
            this.setState({ listdata: listdata });
            this.setState({ statementAccountsModal: true });
        });
    };
    onClickActivityLog = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_sale_id", listdata.id);
        this.setState({ redirect: "/sale/log" });
    }
    onClickActivityLogPayments = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_sale_id", listdata.id);
        this.setState({ redirect: "/payments/log" });
    }
    handleDeletejob = () => {
        // const { onDeleteJobList } = this.props;
        const { listdata } = this.state;
        if (listdata.id !== undefined) {
            // onDeleteJobList(listdata);
            Promise.all([cancel_sale(this.state.recordDeleteID)]).then((values) => {
                showToast("Success", "Sale Canceled Successfully", "success");
                Promise.all([get_all_sales()]).then((values) => {
                    this.setState({ listData: values[0] });
                });
            }).catch((error) => {
                showToast("Failed", "Sale Not Canceled Successfully", "error");
            });
            this.setState({ cancelModal: false });
        }
    };

    onClickView = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_sale_id", listdata.id);
        this.setState({ redirect: "/sale/view" });
    }

    handleCancel = () => {
        const { listdata } = this.state;
        if (listdata.id !== undefined) {
            Promise.all([cancel_sale(this.state.recordDeleteID)]).then((values) => {
                showToast("Success", "Sale Canceled Successfully", "success");
                Promise.all([get_all_sales()]).then((values) => {
                    this.setState({ listData: values[0] });
                });
            }).catch((error) => {
                showToast("Failed", "Sale Not Canceled Successfully", "error");
            });
            this.setState({ cancelModal: false });
        }
    };
    handleRecordClicks = () => {
        this.setState({ listdata: "", isEdit: false });
        this.toggle();
    };

    handleRecordClick = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_sale_id", listdata.id);
        this.setState({ redirect: "/sales/edit" });
    };
    handleListPayment = arg => {
        const listdata = arg;
        window.localStorage.setItem("payments_sale_id", listdata.id);
        this.setState({ redirect: "/salepayments/list" });
    };
    onClickSendEmail = arg => {
        const listdata = arg;
        this.setState({ sendEmailModalID: listdata.id });
        this.setState({ sendEmailModal: true });
    };
    render() {
        //meta title
        document.title = "List Sales";
        const { isEdit, cancelModal, infoModal, sendEmailModal, sendEmailModalID, paymentScheduleModal, welcomeLetterModal, paymentSummaryModal, statementAccountsModal } = this.state;
        const listdata = this.state.listdata;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }
        const columns = [
            {
                dataField: "property_name",
                text: "Property Name",
                sort: true,
            },
            {
                dataField: "project_name",
                text: "Project Name",
                sort: true,
            },
            {
                dataField: "sale_date",
                text: "Sale Date",
                sort: true,
            },
            {
                dataField: "sales",
                isDummyField: true,
                text: "Sales",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {saleView ? <>
                                {saleLog ? <>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-primary"
                                            onClick={() => this.onClickActivityLog(listdata)}
                                        >
                                            <i className="mdi mdi-file-document-outline" id="logtooltip" />
                                            <UncontrolledTooltip placement="top" target="logtooltip">
                                                Activity Log
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                </> : <></>}
                            </> : <></>}
                            {saleView ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-primary"
                                        onClick={() => this.onClickView(listdata)}
                                    >
                                        <i className="mdi mdi-eye-outline" id="viewtooltip" />
                                        <UncontrolledTooltip placement="top" target="viewtooltip">
                                            View
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            {saleEdit ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => this.handleRecordClick(listdata)}
                                    >
                                        <i className="mdi mdi-pencil-outline" id="edittooltip" />
                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                            Edit
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            {saleDelete ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-danger"
                                        onClick={() => this.onClickCancel(listdata)}
                                    >
                                        <i className="mdi mdi-close-circle-outline" id="canceltooltip" />
                                        <UncontrolledTooltip placement="top" target="canceltooltip">
                                            Cancel
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => this.onClickInfo(listdata)}
                                >
                                    <i className="mdi mdi-information-outline" id="infotooltip" />
                                    <UncontrolledTooltip placement="top" target="infotooltip">
                                        Quick Info
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                            {salesDocumentsEmailSend ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => this.onClickSendEmail(listdata)}
                                    >
                                        <i className="mdi mdi-email-send-outline" id="sendInvoiceEmailtooltip" />
                                        <UncontrolledTooltip placement="top" target="sendInvoiceEmailtooltip">
                                            Email Welcome Pack
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                        </ul>
                    </>
                ),
            },
            {
                dataField: "Payment",
                isDummyField: true,
                text: "Payments",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            {saleView ? <>
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => this.handleListPayment(listdata)}
                                    >
                                        <i className="mdi mdi-view-list-outline" id="listOfPayments" />
                                        <UncontrolledTooltip placement="top" target="listOfPayments">
                                            List of Payments
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>
                            </> : <></>}
                            {saleView ? <>
                                {paymentsLog ? <>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-primary"
                                            onClick={() => this.onClickActivityLogPayments(listdata)}
                                        >
                                            <i className="mdi mdi-file-document-outline" id="logtooltip" />
                                            <UncontrolledTooltip placement="top" target="logtooltip">
                                                Activity Log
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                </> : <></>}
                            </> : <></>}
                        </ul>
                    </>
                ),
            },
            {
                dataField: "documents",
                isDummyField: true,
                text: "Documents",
                formatter: (cellContent, listdata) => {
                    if (saleDocumentView) {
                        return (
                            <>
                                <ul className="list-unstyled hstack gap-1 mb-0">
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-success"
                                            onClick={() => this.onClickWelcomeLetter(listdata)}
                                        >
                                            <i className="mdi mdi-file-document-outline" id="welcomelettertooltip" />
                                            <UncontrolledTooltip placement="top" target="welcomelettertooltip">
                                                Welcome Letter
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-info"
                                            onClick={() => this.onClickPaymentSchedule(listdata)}
                                        >
                                            <i className="mdi mdi-calculator" id="paymentscheduletooltip" />
                                            <UncontrolledTooltip placement="top" target="paymentscheduletooltip">
                                                Payment Schedule
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-info"
                                            onClick={() => this.onClickPaymentSummary(listdata)}
                                        >
                                            <i className="mdi mdi-calculator" id="paymentsummarytooltip" />
                                            <UncontrolledTooltip placement="top" target="paymentsummarytooltip">
                                                Payment Summary
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="#"
                                            className="btn btn-sm btn-soft-info"
                                            onClick={() => this.onClickStatementAccounts(listdata)}
                                        >
                                            <i className="mdi mdi-calculator" id="statementaccountstooltip" />
                                            <UncontrolledTooltip placement="top" target="statementaccountstooltip">
                                                Statement of Accounts
                                            </UncontrolledTooltip>
                                        </Link>
                                    </li>
                                </ul>
                            </>
                        )
                    } else
                        return null
                },
            },

        ];

        const defaultSorted = [
            {
                dataField: "id",
                order: "asc",
            },
        ];

        const pageOptions = {
            sizePerPage: 10,
            // totalSize: productsData.length, // replace later with size(customers),
            custom: true,
        };

        // Select All Button operation
        const selectRow = {
            mode: "checkbox",
        };

        const { SearchBar } = Search;

        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                this.setState({ recordDeleteID: row.id });
            }
        }
        return (
            <React.Fragment>
                <SendEmailModal
                    show={sendEmailModal}
                    flag={'email_welcome_pack'}
                    id={sendEmailModalID}
                    payload={{}}
                    onCloseClick={() => this.setState({ sendEmailModal: false })}
                />
                <CancelModal
                    show={cancelModal}
                    onDeleteClick={this.handleCancel}
                    record={`property`}
                    onCloseClick={() => this.setState({ cancelModal: false })}
                />
                <QuickInfoModal
                    show={infoModal}
                    record={listdata}
                    onCloseClick={() => this.setState({ infoModal: false })}
                />
                <WelcomePaymentModal
                    show={welcomeLetterModal}
                    record={listdata}
                    title="Welcome Letter"
                    generated_docs_detail_response={this.state.generated_docs_detail_response?.welcome_letter_generate}
                    onCloseClick={() => this.setState({ welcomeLetterModal: false })}
                />
                <WelcomePaymentModal
                    show={paymentScheduleModal}
                    record={listdata}
                    title="Payment Schedule"
                    generated_docs_detail_response={this.state.generated_docs_detail_response?.payment_schedule_generate}
                    onCloseClick={() => this.setState({ paymentScheduleModal: false })}
                />
                <SummaryStatementModal
                    show={paymentSummaryModal}
                    record={listdata}
                    generated_docs_detail_response={this.state.generated_docs_detail_response?.payment_summary_generate}
                    title="Payment Summary"
                    onCloseClick={() => this.setState({ paymentSummaryModal: false })}
                />
                <SummaryStatementModal
                    show={statementAccountsModal}
                    record={listdata}
                    generated_docs_detail_response={this.state.generated_docs_detail_response?.statement_of_accounts_generate}
                    title="Statement Of Accounts"
                    onCloseClick={() => this.setState({ statementAccountsModal: false })}
                />
                <div className="page-content">
                    <div className="container-fluid">
                        <Breadcrumbs title="Sales" breadcrumbItem="List Sales" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1">List Sales</h5>
                                                {saleCreate ? <>
                                                    <div className="flex-shrink-0">
                                                        <Link to="/sales/add" className="btn btn-primary me-1">Add New Sale</Link>
                                                    </div>
                                                </> : <></>}
                                            </div>
                                        </CardBody>
                                        <PaginationProvider
                                            pagination={paginationFactory(pageOptions)}
                                            keyField="id"
                                            columns={columns}
                                            data={this.state.listData}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField="id"
                                                    columns={columns}
                                                    data={this.state.listData}
                                                    search
                                                >
                                                    {toolkitProps => (
                                                        <React.Fragment>
                                                            <Row className="mb-2">
                                                                <Col md="4">
                                                                    <div className="search-box me-2 mb-2 d-inline-block">
                                                                        <div className="position-relative">
                                                                            <SearchBar
                                                                                {...toolkitProps.searchProps}
                                                                            />
                                                                            <i className="bx bx-search-alt search-icon" />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col xl="12">
                                                                    <div className="table-responsive">
                                                                        <BootstrapTable
                                                                            keyField={"id"}
                                                                            responsive
                                                                            bordered={false}
                                                                            striped={false}
                                                                            defaultSorted={defaultSorted}
                                                                            rowEvents={rowEvents}
                                                                            classes={
                                                                                "table align-middle table-nowrap"
                                                                            }
                                                                            headerWrapperClasses={"thead-light"}
                                                                            {...toolkitProps.baseProps}
                                                                            {...paginationTableProps}
                                                                            ref={this.node}
                                                                        />
                                                                        <Modal
                                                                            isOpen={this.state.modal}
                                                                            className={this.props.className}
                                                                        >
                                                                            <ModalHeader toggle={this.toggle} tag="h4">
                                                                                {!!isEdit ? "Edit Sale" : "Add Sale"}
                                                                            </ModalHeader>
                                                                            <ModalBody>
                                                                                <Formik
                                                                                    enableReinitialize={true}
                                                                                    initialValues={{
                                                                                        id: (listdata && listdata.id) || '',
                                                                                        name: (listdata && listdata.name) || '',
                                                                                    }}
                                                                                    validationSchema={Yup.object().shape({
                                                                                        id: Yup.string().required("Please Enter Your Id"),
                                                                                        name: Yup.string().required("Please Enter Your Name"),
                                                                                    })}
                                                                                    onSubmit={values => {
                                                                                        this.toggle();
                                                                                    }}
                                                                                >
                                                                                    {({ errors, status, touched }) => (
                                                                                        <Form>
                                                                                            <Row>
                                                                                                <Col className="col-12">
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                            Property Type Id
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="id"
                                                                                                            disabled
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.id &&
                                                                                                                    touched.id
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="id"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                            Name
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="name"
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.name &&
                                                                                                                    touched.name
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="name"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <div className="text-end">
                                                                                                        <button
                                                                                                            type="submit"
                                                                                                            className="btn btn-primary save-user"
                                                                                                        >
                                                                                                            Save
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Form>
                                                                                    )}
                                                                                </Formik>
                                                                            </ModalBody>
                                                                        </Modal>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row className="align-items-md-center mt-30">
                                                                <Col className="inner-custom-pagination d-flex">
                                                                    <div className="d-inline">Results Per Page&nbsp;&nbsp;
                                                                        <SizePerPageDropdownStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                    <div className="text-md-right ms-auto">
                                                                        <PaginationListStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    )}
                                                </ToolkitProvider>
                                            )}
                                        </PaginationProvider>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default ListSales;
